import { useSelector } from "react-redux";
import { useState } from "react";
import capitalize from "antd/es/_util/capitalize";
import styles from "../../../styles/Components/new-dashboard/market-overview/MarketOverviewContent.module.css";
import { BsNewspaper } from "react-icons/bs";
import { Link } from "react-router-dom";

function MarketOverviewContent() {
  const {
    dashboard: {
      analyticsinfo: {
        analytics: { analysis_by_category: analysis = {} } = {},
      },
    },
  } = useSelector((state) => state);

  const categories = Object.keys(analysis);

  const [currentCategory, setCurrentCategory] = useState(categories?.[0]);

  const categoryData = analysis?.[currentCategory];
  const categoryHeadlines = categoryData?.headlines;
  const sentiment = categoryData?.sentiment_analysis;
  const {
    details: {
      sentiment_label: label,
      average_sentiment_score: average,
      source,
      summary,
    } = {},
  } = sentiment || {};
  // console.log(categoryHeadlines, sentiment);

  return (
    <div>
      <ul className={styles.tabs}>
        {categories?.map((category) => (
          <li
            key={category}
            className={`${styles.tabItem} ${currentCategory === category ? styles.active : ""}`}
            onClick={() => setCurrentCategory(category)}
          >
            {capitalize(category)}
          </li>
        ))}
        <li
          className={`${styles.tabItem} ${currentCategory === "more" ? styles.active : ""}`}
          onClick={() => setCurrentCategory("more")}
        >
          More
        </li>
      </ul>

      {currentCategory !== "more" && categoryHeadlines?.length > 0 && (
        <div className={styles.container}>
          <div className={styles.summary}>
            <h4 className={styles.title}>Executive Summary</h4>
            <div className={styles.summaryBox}>
              <li className={styles.summaryInfo}>
                <span className={styles.label}>Sentiment Label:</span>
                <span
                  className={styles.value}
                  style={
                    label?.includes("Positive") ? { color: "#0AAF47" } : {}
                  }
                >
                  {label}
                </span>
              </li>
              <li className={styles.summaryInfo}>
                <span className={styles.label}>Average Sentiment Score:</span>
                <span className={styles.value}>{average?.toFixed(2)}</span>
              </li>
              <li className={styles.summaryInfo}>
                <span className={styles.label}>Source:</span>
                <span className={styles.value}>{source}</span>
              </li>
            </div>
            <div className={styles.sentimentSummary}>{sentiment?.summary}</div>
          </div>
          <div className={styles.marketHeadlines}>
            <div className={styles.title}>
              Latest {capitalize(currentCategory)} Headlines
            </div>
            <ul className={styles.headlineList}>
              {categoryHeadlines?.map((headline) => (
                <li key={headline?.link}>
                  <a
                    className={styles.headlineLink}
                    href={headline?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsNewspaper color="#0c4cfc" size={16} />
                    {headline?.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/*{currentCategory !== "more" && (*/}
      {/*  <div className={styles.marketSentiment}>*/}
      {/*    <div className={styles.sentimentTitle}>AI Market Sentiment</div>*/}
      {/*    <p>{sentiment?.summary}</p>*/}
      {/*    <p>{sentiment?.details?.suggestions?.[0]}</p>*/}
      {/*  </div>*/}
      {/*)}*/}

      {currentCategory === "more" && (
        <div className={styles.moreOverview}>
          <p>
            Explore more asset classes and market data in the Insights section.
          </p>
          <Link to="/insight">Go to Insights</Link>
        </div>
      )}
    </div>
  );
}

export default MarketOverviewContent;
